/**
 * @packageDocumentation
 * @module f1/fn
 */

export interface Skip {
  /**
   * To skip providing a value, most application require `undefined` or we pass the value through
   *
   * @public
   * @function f1.skip
   * @example
   *
   * ```ts
   * f1.skip() => undefined
   * f1.skip(1) => 1
   * ```
   */
  <V>(value: V): V;
  <V>(value: undefined): undefined;
  <V>(value?: V): V;
}

/**
 * @see Skip
 */
export default <V>(value?: V): V | undefined => value;
